<template>
    <contract-list 
        ref="list"
        header-text="契約"
        :has-add="true"
        @add="addContract"
        mt>
        <div v-if="getListObj">
            <div v-if="getListObj.data.length > 0">
                <div class="card mb-2 let-sapce-1" v-for="item in getListObj.data" :key="item.id">
                    <div class="card-header px-2 pb-1">
                        <div class="d-flex">
                            <span>ap.{{item.apply_id}}/ {{converVal('contract_flg', item.contract_flg)}} </span>
                            <span class="text-muted pl-2 ml-auto" @click="openMenu(item.id)">
                                <i class="fas fa-ellipsis-v"></i>
                            </span>
                        </div>
                        <div class="d-flex"><span class="text-truncate">案件: {{item.pj_group_nm}} </span></div>
                        <div class="d-flex"><span class="text-truncate">要員: {{item.te_group_nm}}</span></div>
                    </div>
                    <div class="card-body p-2" @click="toContractDetail(item.id)">
                        <div> 名前:{{item.private_nm}} </div>
                        <div> 期間：{{item.start_month + item.start_day | dformatd}} ~ {{item.end_month + item.end_day | dformatd}}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- メニュー -->
        <contract-menu ref="menu" list-nm="契約" act="app.contract.del"></contract-menu>

    </contract-list>
</template>

<script>
    import {converVal} from 'pages/commons/form/selectList'
    import ContractMenu from 'pages/commons/form/Delete'
    import ContractList from 'pages/commons/List/List'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            ContractList,
            ContractMenu
        },
        mounted () {
            this.$refs.list.loadListObj({
                url:'app.contract',
                data: '0' 
            })
            this.$refs.list.resetRefresh('contractList')
        },
        activated () {
            this.$refs.list.isGetList('contractList', { url:'app.contract', data: '0'})
            this.$refs.list.resetRefresh('contractList')
        },
        computed: {
            ...mapGetters(['getListObj'])
        },
        methods: {
            addContract () {
                this.$router.push({name: 'ContractCreate', params:{
                    do: 'create'
                }})
            },
            toContractDetail (id) {
                this.$router.push({name: 'ContractCreate', params:{
                    do: 'show',
                    id: id
                }})
            },
            openMenu (id) {
                this.$refs.menu.openThis(id)
            },
            seeMoreMt () {
                this.$store.dispatch('loadListObjSeeMore', {
                    url:'app.contract',
                    skip: this.$refs.list.lastId
                })
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            formatDate (month, day) {
                let str = month +  day
                return str.replace('-', '/')
            }
        }
    }
</script>
